export default __webpack_public_path__ + "static/cspTransparent-9c1d53da79ca490db4eb12620e37ee9f.png";